import { ACTIONS_PAGE_PATH } from "shared/pages/ActionsPage";
import { DEPOSIT_COLLECTOR_PAGE_PATH } from "shared/pages/DepositCollectorPage";
import { MEMBERS_BOT_PAGE_PATH } from "shared/pages/MembersBotPage";
import { REFERRALS_PAGE_PATH } from "shared/pages/ReferralsPage";
import { WEWORK_CAMPAIGN_PAGE_PATH } from "shared/pages/WeworkCampaignPage";

const NavigationConstants = {
  homePageRoute: "/",
  signUp: "/signup",
  shortSignup: "/shortsignup",
  notFound404: "/404",
  offerExpired: "/offerExpired",
  finishSignUp: "/finishSignUp",
  depositCollector: DEPOSIT_COLLECTOR_PAGE_PATH,
  admin: "/admin",
  weworkCampaign: WEWORK_CAMPAIGN_PAGE_PATH,
  members: MEMBERS_BOT_PAGE_PATH,
  genericBot: "/bot",
  referrals: REFERRALS_PAGE_PATH,
  actionsPage: ACTIONS_PAGE_PATH,
  partners: "/partners",
  connectPlaid: "/connect/bank",
  getCoverage: "/get_coverage",
  myAccount: "/myaccount",
  login: '/login',
  addCoverage: '/addplan',
  managePlan: '/manageplan',
  manageLoan: '/manageloan',
  cancelPlan: '/cancel',
  brokers: "/brokers",
  payments: '/payment',
  oldDashboard : "/operators",
  pendingLead : "/applicationUnderReview",
  thankYou : "/thankYou",
  businessLoan : "/businessloan",
  quickRent : "/rentfinancing",
  sbaLoan: "/sbaloan"

};

export default NavigationConstants;



// WEBPACK FOOTER //
// ./src/scenes/Navigation/NavigationConstants.ts